import { defineAction } from '~/prix'
import generateActionAction from './generateAction.action.json' with { type: 'json' }
import { z } from 'zod'

const generateActionDefinition = defineAction({
  ...generateActionAction,

  input: z.object({
    typescript: z.boolean().default(false),
    ts: z.boolean().default(false),
    sectorName: z.string(),
    entityName: z.string(),
    actionName: z.string(),
    description: z.string(),
  }),
  output: z.object({}),
})

export default generateActionDefinition
